import { faPlay } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useStyles } from './ProductVideoAction.styles'
import { PopoverHover } from '@labrav/react-components'
import { useState } from 'react'
import { VideoModal } from './VideoModal'

interface ProductVideoActionProps {
  actionTitle: string
  actionLable: string
  videoLink: string
  tooltip: string
  id?: string
}
export const ProductVideoAction = ({
  actionLable,
  actionTitle,
  videoLink,
  tooltip,
  id,
}: ProductVideoActionProps) => {
  const { classes } = useStyles()
  const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false)

  const handleOpenVideoModal = () => {
    setIsVideoModalOpen(true)
  }
  return (
    <>
      <PopoverHover
        tooltipPlacement="right"
        horizontalPlacement={'left'}
        description={<div className={classes.tooltipWrapper}>{tooltip}</div>}
        tooltipWidth="230px"
        tooltipPlacmentGap="20px"
      >
        <div
          className={classes.actionWrapper}
          data-testid={'product-video-section'}
          id={id}
          onClick={handleOpenVideoModal}
        >
          <div className={classes.actionContainer}>
            <div className={classes.actionLable} data-testid={'action-lable'}>
              <div>{actionTitle}</div>
              <div>{actionLable}</div>
            </div>
            <div className={classes.play}>
              <FontAwesomeIcon
                icon={faPlay}
                style={{
                  width: '15px',
                  height: '12px',
                  position: 'absolute',
                  margin: 'auto',
                  color: '#FFFFFF',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              />
            </div>
          </div>
        </div>
      </PopoverHover>
      {isVideoModalOpen && (
        <VideoModal
          actionLable={actionLable}
          actionTitle={actionTitle}
          videoLink={videoLink}
          isVideoModalOpen={isVideoModalOpen}
          setIsVideoModalOpen={setIsVideoModalOpen}
        />
      )}
    </>
  )
}
